import React, { Component, useEffect } from 'react';
import {  Grid, Box, TableFooter, Button, Typography, Paper, Link } from '@material-ui/core';
import { Fragment } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';


import { SingleSwitch } from '../../../../../commonModules/MUI/RadioAndCheckbox';
import { useSelector } from 'react-redux';
import GenerateQrCode from '../../products/GenerateQrCode';
import QRCode from 'react-qr-code';

const SingleTransferQrCode = (props) => {

    // useEffect = () => {
    //     console.log('===============SingleTransferBody=====================');
    //     console.log({props});
    //     console.log('====================================');

    // }
    // const { addFiles, spendingID, spending_id, factExist, addFactures, partDetails } = this.state;
    const { client, shopDest, transfer, agent, commercial, shop, TVAOpt } = props;
    // let list = []
    // let total_payed = 0
    // let rest = 0

    // console.log('====================================');
    // console.log(this.state.factList, );
    // console.log( this.state.factList.split(", "));
    // console.log( Object.keys(factExist));
    // console.log('====================================');

    // if(transfer.sale_credit) {
    //     list = this.filterList()
    //     list.forEach(item => total_payed += item.amount)
    //     console.log({list});
    //     rest = transfer.total_price - total_payed
    // }   

    return(
        <Box p={1} style={{ display: 'flex', justifyContent: "space-between", alignItems: "end"}}>
            {props.children}
            <Box className="element">
            {/* <Box className="element"> */}
                {/* <div className="corner top-left"></div>
                <div className="corner top-right"></div>
                <div className="corner bottom-left"></div>
                <div className="corner bottom-right"></div> */}
                <Box p={2}>
                    <QRCode
                        size={150}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={props.id}
                        viewBox={`0 0 100 100`}
                        id="QRCode"
                    />
                </Box>
            </Box>
        </Box>           
    );
}


export default SingleTransferQrCode;
